import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Button, Grid, Typography } from "antd";
import { ArrowLeftOutlined,} from "@ant-design/icons";
import CategoryList from "./components/CategoryList";
import { fetchCategories } from "../../store/commonThunks/lookups";
import { selectCategories } from "../../store/commonSelectors/lookupsSelectors";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const Category = () => {
  const dispatch = useDispatch();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const categories = useSelector(selectCategories);

  const navigate =useNavigate();
  const handleNavigateToBack = () => {
  navigate("/inventory/dashboard");
  };

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  return (
    <>
      <div
		style={{
			display: "flex",
			alignItems: "center",
			marginBottom: "24px",
		}}
		>
		<Button
			type="text"
			icon={<ArrowLeftOutlined style={{ fontSize: !screens.md ? "18px" : "22px" }} />} // ✅ Scaled to match Title
			onClick={handleNavigateToBack}
			style={{
			marginRight: 12,
			padding: 0,
			height: "auto",
			lineHeight: "1",
			color: "#000", // optional, keeps consistent with text color
			}}
		/>
		<Title
			level={!screens.md ? 4 : 2}
			style={{
				margin : 0,
				whiteSpace: "normal",
				wordBreak: "break-word",
				textAlign: !screens.md ? "center" : "left",
			}}
		>

			Item Category Manage
		</Title>
		</div>
      <CategoryList categories={categories} />
    </>
  );
};

export default Category;
